import React from "react";

export default function NotFound() {
  return (
    <div className="container NotFound">
      <h3>Page not found</h3>
    </div>
  );
}
